var VideoBlock = /** @class */ (function () {
    function VideoBlock(element) {
        this.videoBlock = element;
        this.videoWrapper = this.videoBlock.querySelector('.video-wrapper');
        this.videoToggle = this.videoWrapper.querySelector('.play-toggle');
        if (this.videoToggle) {
            this.init();
        }
    }
    VideoBlock.prototype.init = function () {
        var _this = this;
        this.videoToggle.addEventListener('click', function () {
            _this.videoWrapper.classList.add('playing');
            _this.videoWrapper.querySelector('video').play();
        });
    };
    return VideoBlock;
}());
export default VideoBlock;
